import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getClinicRequest, setSelectedClinic } from 'src/modules/auth/store/authActions';
import { push } from 'redux-first-history';

const SelectClinicContainer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const fetchData = async () => {
      try {
        const response = await new Promise((resolve, reject) => {
          dispatch(getClinicRequest(token, resolve, reject));
        });

        if (response && Array.isArray(response.data) && response.data.length > 0) {
          const savedClinicId = localStorage.getItem('selectedClinicId');
          const clinic = response.data.find((c) => c.id === savedClinicId) || response.data[0];
          localStorage.setItem('selectedClinicId', clinic.id);
          localStorage.setItem('selectedClinic', JSON.stringify(clinic));
          dispatch(setSelectedClinic(clinic));
        }
      } catch (e) {
        console.error('Error fetching clinic in SelectClinicContainer:', e);
      } finally {
        dispatch(push('/tasks'));
      }
    };

    fetchData();
  }, [dispatch]);

  return null;
};

export default SelectClinicContainer;
